export enum Theme {
  Dark = "dark",
  Light = "light",
}

export const LOCAL_STORAGE_THEME_KEY = "theme";
